import { component } from 'picoapp';
import axios from 'axios';

function PostsFeaturedProducts(node){
  const btns = node.querySelectorAll('.button--add-to-cart')
  
  const init = () => {
    bindEvents()
    updateBtns()
  }

  const updateBtns = () => {
    axios
      .get('/cart.js', { headers: { Pragma: 'no-cache' }})
      .then((response) => {
        const cartData = response.data;
        btns.forEach(btn => {
          if(cartData.items.find(i => i.variant_id == btn.dataset.productId)){
            btn.querySelector('.text').innerText = 'Added'
            btn.setAttribute('disabled', 'disabled')
          }
        })
      })
      .catch(function (error) {
        console.log(error);
      });
    
  }

  const bindEvents = () => {
    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        btn.querySelector('.text').innerText = 'adding to cart'
        addProductToCart(btn.dataset.productId)
      })
    })
  }

  const addProductToCart = (id) => {
    
    axios
      .post('/cart/add.js', {
        id: id,
        quantity: 1
      })
      .then((response) => {
        if(response.status == 200){
          window.location.reload()
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  
  init()
  
} 

export default component((node, ctx) => {
  new PostsFeaturedProducts(node, ctx);
});
